"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPieConfiguration = void 0;
var tslib_1 = require("tslib");
var helpers_1 = require("../_chartCreators/helpers");
var responsive_1 = require("../_chartCreators/responsive");
function getPieConfiguration(config) {
    var pieConfiguration = {
        chart: {
            type: "pie",
            events: {
                load: function () {
                    var _a, _b, _c, _d, _e;
                    var distance = -(((_d = (_c = (_b = (_a = this.series[0].points) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.shapeArgs) === null || _c === void 0 ? void 0 : _c.r) !== null && _d !== void 0 ? _d : 30) / 3);
                    var options = {
                        type: "pie",
                        dataLabels: {
                            distance: distance,
                        },
                    };
                    this.series[0].update(options);
                    helpers_1.alignChart(this, (_e = config.chart) === null || _e === void 0 ? void 0 : _e.verticalAlign);
                },
            },
        },
        plotOptions: {
            pie: {
                size: "100%",
                allowPointSelect: false,
                dataLabels: {
                    enabled: false,
                },
                showInLegend: true,
            },
        },
        legend: {
            enabled: false,
        },
    };
    if (config === null || config === void 0 ? void 0 : config.enableCompactSize) {
        return tslib_1.__assign(tslib_1.__assign({}, pieConfiguration), { responsive: responsive_1.getPieResponsiveConfig() });
    }
    return pieConfiguration;
}
exports.getPieConfiguration = getPieConfiguration;
//# sourceMappingURL=pieConfiguration.js.map